<script>
    import { ExtensionStore } from "$/stores/ExtensionStore";
    import { clickAction } from "$/utils/clickAction";
    import Logo from "./Logo.svelte";

    let settingsClicked = false;

    const clickSettignsImp = () => {
        settingsClicked = !settingsClicked;
        ExtensionStore.toggleSettingsPanel();
    };
</script>

<nav>
    <div class="left-spacer"></div>

    <Logo />
    <div class="settings-button" use:clickAction={clickSettignsImp}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="settings-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
            class:rotate-full={settingsClicked}
            class:rotate-half={!settingsClicked}
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
        </svg>
    </div>
</nav>

<style>
    @import "../main.css";

    nav {
        @apply reset flex h-10 min-h-min w-full select-none items-center justify-between bg-gray-700 px-3 py-2 !important;
    }

    nav svg {
        @apply reset h-full !important;
    }

    .settings-button {
        @apply flex align-middle !important;
    }

    .settings-icon {
        @apply reset ml-auto h-5 w-5 cursor-pointer text-white transition-all !important;
    }

    .settings-icon svg {
        @apply text-white !important;
    }

    .settings-icon path {
        @apply fill-transparent text-white !important;
    }

    .settings-icon:hover path,
    svg:hover use {
        @apply fill-transparent !important;
    }

    .rotate-half {
        @apply hover:rotate-90 !important;
    }

    .rotate-full {
        @apply rotate-180 !important;
    }

    .left-spacer {
        @apply h-5 w-5 !important;
    }
</style>
